const FEATURE_FLAG_NAMES = {
    OPTIONAL_TIPS_COPY_TREATMENT: 'driver-tips-optional-copy',
    UP_SELLS_CAROUSEL_PLP: 'upsells-carousel-plp',
    UP_SELLS_CAROUSEL_PDP: 'upsells-carousel-pdp',
    PLUS_MEMBERSHIP: 'membership',
    MOBILE_PAYMENT_CTA: 'mobile-payment-cta',
    SNAP_EBT: 'snap-ebt',
    PROGRAMMATIC_SEEDING: 'programmatic-seeding',
    CAROUSEL_PRODUCT_PERSONALIZATION: 'carousel-product-personalization',
    PLUSMEMBER_FT_FOR_ALL_PHASE1: 'mplus-for-all-phase1',
    BACK_IN_STOCK_WAITLIST: 'back-in-stock-waitlist',
    FUNNEL_REGISTRATION_TEST_V2: 'funnel-registration-test-v2',
};

export { FEATURE_FLAG_NAMES };
